export const meeting  =  "/assets/jpg/meeting.jpg";
export const damage  =  "/assets/svg/damage.svg";
export const savings  =  "/assets/svg/savings.svg";
export const geographical  =  "/assets/svg/geographical.svg";
export const download  =  "/assets/svg/download.svg";
export const footer  =  "/assets/png/footer2.jpg";
export const arrowRight  =  "/assets/svg/right.svg";
